import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface MarkListingPhotoAs360Options {
  format: string;
  set360: boolean;
}

interface MarkListingPhotoAs360Output {
  id: number;
  url: string;
  category: string;
  type: string;
}

export default (makeCall: MakeCall) => (
  listingId: number,
  photoId: number,
  { set360, format }: MarkListingPhotoAs360Options,
) =>
  makeCall<MarkListingPhotoAs360Output>(
    'PUT',
    `${APIV2_URL}/listing/${listingId}/photo/${photoId}`,
    {
      query: { format },
      data: {
        set360,
      },
    },
  );
